// extracted by mini-css-extract-plugin
module.exports = {"container":"Aniversariantes_container__3Y9he","aniversariantes":"Aniversariantes_aniversariantes__2idyJ","data":"Aniversariantes_data__1UCjQ"};